import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SetupEquipmentComponent } from './pages/setup-equipment.component';
import { SharedModule } from '../../shared/shared.module';
import { SetupEquipmentService } from './setup-equipment.service';
import { MaterialModule } from '../../shared/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RequestNewModelPopupComponent } from './request-new-model-popup/request-new-model-popup.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule
    ],
    declarations: [SetupEquipmentComponent, RequestNewModelPopupComponent],
    providers: [
        SetupEquipmentService
    ]
})
export class SetupEquipmentModule { }
